import { render } from "./shareDownload.vue?vue&type=template&id=0aaa0813&scoped=true"
import script from "./shareDownload.vue?vue&type=script&lang=js"
export * from "./shareDownload.vue?vue&type=script&lang=js"

import "./shareDownload.vue?vue&type=style&index=0&id=0aaa0813&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aaa0813"]])

export default __exports__